'use client'

import { useEffect, useState } from 'react'
import { Project } from '@models/Project'
import { scrollSpy } from 'react-scroll'

import { useAppStore } from '@/entities/app-store'

export function useProjectsFromStore() {
  const appStore = useAppStore()
  const [projects, setProjects] = useState<Project[] | null>(null)
  const storeProjects = appStore?.appState?.projects

  useEffect(() => {
    // Updating scrollSpy when the component mounts.
    scrollSpy.update()
    setProjects(storeProjects)
  }, [storeProjects])

  return projects
}
